"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickbooksDesktopReport = exports.QuickbooksDesktopReportQuery = exports.QuickbooksDesktopPaymentRow = exports.QuickbooksDesktopInvoiceRow = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.QuickbooksDesktopInvoiceRow = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('Invoice'),
    customer: typebox_1.Type.String(),
    issueDate: typebox_1.Type.String(),
    invoice: typebox_1.Type.String(),
    depositAccount: typebox_1.Type.String(),
    salesTaxItem: typebox_1.Type.String(),
    item: typebox_1.Type.String(),
    qty: typebox_1.Type.String(),
    price: typebox_1.Type.String(),
    salesTaxCode: typebox_1.Type.String(),
});
exports.QuickbooksDesktopPaymentRow = typebox_1.Type.Object({
    type: typebox_1.Type.Literal('Invoice Payment'),
    customer: typebox_1.Type.String(),
    paymentIdentifier: typebox_1.Type.String(),
    paymentDate: typebox_1.Type.String(),
    memo: typebox_1.Type.String(),
    applyToInvoice: typebox_1.Type.String(),
    amount: typebox_1.Type.String(),
    depositTo: typebox_1.Type.String(),
});
exports.QuickbooksDesktopReportQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    dateFrom: typebox_1.Type.String({ format: 'date' }),
    dateTo: typebox_1.Type.String({ format: 'date' }),
}));
exports.QuickbooksDesktopReport = typebox_1.Type.Object({
    invoices: typebox_1.Type.Array(exports.QuickbooksDesktopInvoiceRow),
    payments: typebox_1.Type.Array(exports.QuickbooksDesktopPaymentRow),
});
//# sourceMappingURL=quickbooks-desktop.js.map